import React from 'react';
import { getPlayerNameColor, formatSessionGamesCountLabel } from '../../utils/playerUtils';

/**
 * Compact row shown under the cursor while dragging (e.g. waitlist → court).
 * Matches on-court rows: name + session games (Elo lives on full card tooltip).
 */
export function RosterDragOverlayPreview({ player }) {
  if (!player) return null;
  const gamesLabel = formatSessionGamesCountLabel(player);

  return (
    <div className="pointer-events-none flex min-w-[12rem] max-w-[18rem] items-center gap-2 rounded-md border border-border-medium bg-surface px-2.5 py-1.5 shadow-brand-lg">
      <span
        className={`min-w-0 flex-1 truncate text-base font-medium ${getPlayerNameColor(player.gender)}`}
        title={player.name}
      >
        {player.name}
      </span>
      <span className="shrink-0 text-sm tabular-nums text-text-muted" title="Games this session">
        {gamesLabel}
      </span>
    </div>
  );
}
